import { Component, OnInit, OnChanges, Input, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { ChartDataSets, ChartOptions } from 'chart.js';
import { Color} from 'ng2-charts';

@Component({
  selector: 'app-line-chart',
  templateUrl: './line-chart.component.html',
  styleUrls: ['./line-chart.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LineChartComponent implements OnInit, OnChanges {
  @Input() linesData: any[];
  
  lineChartData: ChartDataSets[] = [];
  lineChartLabels: Array<any> = [];
  lineChartOptions: any = {
    responsive: true,
    legend: {
      display: true
    },
    scales: {
      yAxes: [{id: 'y-axis-1', type: 'linear', position: 'left', ticks: {min: 0, max: 5},
       scaleLabel: {display: true, labelString: 'Ratings'} }],
      xAxes: [{scaleLabel: {display: true, labelString: 'Date'} }] 
    },
    maintainAspectRatio: false
  };
  lineChartLegend = true;
  lineChartType = 'line';
  public lineChartPlugins = [];
  public lineChartColors: Color[] = [];
  constructor() { }

  drawChart = true;
  ngOnInit() {
  }

  ngOnChanges() {

    if(!this.drawChart){
      return;
    }
    this.setLineData();
    this.drawChart = false;
    setTimeout(() => {
       this.drawChart = true;
     }, 500)
  }

  setLineData() {
    console.log('this.linesData', this.linesData);
    this.lineChartData = [];
    this.linesData.forEach((lineData: any) => {
      console.log('lineData', lineData);
      this.lineChartData.push({label: lineData.title, data: lineData.data, pointRadius: 5, fill: false});
    });
    if (this.linesData && this.linesData.length) {
      this.lineChartLabels = this.linesData[0].labels;
    }
  }

}
